<template>
  <div class="bg-black rounded overflow-hidden relative cursor-pointer" v-auto-animate @click="useUpdateQuery({ restId: restaurant.id, mealIds: mealIds?.join(','), mealTypes: 11 })">
    <div class="absolute z-10 bottom-0 left-0 w-full flex items-end min-h-32 bg-gradient-to-t from-25% from-black/80">
      <div class="p-3 grid gap-3 text-white w-full">
        <div class="relative z-10 w-24 h-12 invert" v-if="restaurant.logo">
          <AtomImage class="h-full !object-contain object-left-bottom" :src="useCloudinaryImage(restaurant.logo, 300, null, 'fit,e_trim')" :alt="restaurant.name" />
        </div>
        <div class="grid gap-0.5">
          <p class="text-sm _min-h-[2.5em] line-clamp-2 max-w-[32ch]" v-if="restaurant.shortDescription" v-html="restaurant.shortDescription" />
        </div>
        <div class="text-sm">
          <AtomRestaurantLocation 
            :name="restaurant.name"
            :address="[restaurant.address, regionTags.map(tag => tag.label)?.join(', ') || restaurant.city].join(', ')" />
        </div>
        <div class="flex items-center gap-6">
          <CampaignsStockholmFashionWeekCardTimeslots 
            class="w-full"
            :restaurant="restaurant"
            :pending="pending" />
          <button class="button-mist text-sm w-12 !py-[0.5em] !px-0">
            <AtomIcon name="circle-info" class="text-lg" /> 
          </button>
        </div>
      </div>
    </div>
    <div class="h-64 opacity-80">
      <AtomImage class="object-cover" :src="useCloudinaryImage(restaurant.cover, 300, 200)" :alt="restaurant.name" />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  restaurant: {
    type: Object,
    default: () => {}
  },
  pending: {
    type: Boolean,
    default: false
  }
})

// Get meal ID's from restaurant
const mealIds = computed(() => props.restaurant.meals?.map(meal => meal.id))

// Get region
const regionTags = computed(() => props.restaurant.tags?.filter(tag => [8, 9, 10].includes(tag.groupId)) || [])
</script>